export const correctTimeInDate = (dateString, timeString) => {
  if (dateString.length === 0 || timeString.length === 0) {
    return '';
  }

  const splittingDate = dateString.split(' ');
  const splittingTime = timeString.split(':');
  const updateTime = splittingDate[1]
    .split(':')
    .map((i, index) => splittingTime[index] ?? i)
    .join(':');
  const updateDate = [splittingDate[0], updateTime];

  return updateDate.join(' ');
};

export const getTodayInMoscowTime = () => {
  const date = new Date();
  const options = {
    timeZone: 'Europe/Moscow',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  };

  const formatter = new Intl.DateTimeFormat('ru-RU', options);
  return formatter.format(date);
};

export const returnDayAndDate = (dateString) => {
  const date = new Date(dateString);
  const formatted = new Intl.DateTimeFormat('ru-RU', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  }).format(date);

  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};
